"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTransactionSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductTransactionSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductTransactionSearchResponse = ProductTransactionSearchResponse;
//# sourceMappingURL=product-transaction-search.response.js.map